export default "__VITE_ASSET__DRM7EOHS__"